import { AdviceContainer } from "@storyplay/common/lib/studio/aop";

const hbAdvisorContainer = new AdviceContainer()
const hbAdvisor = hbAdvisorContainer.getAdvisorDecorator()

export { hbAdvisorContainer, hbAdvisor }